import React, { useState, useEffect } from "react";
import Sidebar from "./Sidebar";
import { Stack, Box, Typography } from "@mui/material";
import Video from "./Video";

import { fetchAPI } from "../utils/fetchAPI";
const Feed = () => {
  const [selectedCategory, setSelectedCategory] = useState("New");
  const [videos, setVideos] = useState([]);

  // Fetch the video
  useEffect(() => {
    setVideos(null);
    const fetchData = async () => {
      const data = await fetchAPI(`search?part=snippet&q=${selectedCategory}`);
      console.log(data);

      setVideos(data);
    };

    fetchData();
  }, [selectedCategory]);

  console.log(videos);
  return (
    <Stack sx={{ flexDirection: { sx: "column", md: "row" } }}>
      <Box
        sx={{
          height: { sx: "auto", md: "auto" },
          borderRight: "1px solid #850E35",
          backgroundColor: "#FFC4C4",
          px: { md: 3, sx: 1 },
        }}
      >
        <Typography variant="body2" className="copyright"></Typography>
        <Sidebar
          selectedCategory={selectedCategory}
          setSelectedCategory={setSelectedCategory}
        />
      </Box>

      <Box
        p={2}
        sx={{
          height: "auto",
          overflowY: "auto",
          backgroundColor: "#FFF5E4",
          flex: 2,
        }}
      >
        <Typography
          variant="h4"
          fontWeight="bold"
          mb={2}
          sx={{ color: "#850E35" }}
        >
          {selectedCategory} <span style={{ color: "#EE6983" }}>Video</span>
        </Typography>
        <Video videos={videos} />
      </Box>
    </Stack>
  );
};

export default Feed;
